<template>
    <main>
       <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                     <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                     </div>
                     <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Edit Budget Subhead</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericEdit v-if="generic" ref="loadGeneric" :urls="urls"></GenericEdit>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/BudgetSubHeads/MenuList.vue";
    import lang from "@/views/modules/BudgetSubHeads/language/en";
    import GenericEdit from "@/components/layout/shared/generic/EditView.vue";

    export default {
        name: "edit-budgetsubheads",
        components: {
            breadcrumbs,
            GenericEdit,
        },
        data() {
            return {
                generic: true,
                metaList: [
                    {
                        type: 'selectcomponent',
                        name: 'budgethead_name',
                        label: lang.LBL_HEAD_NAME,
                        required: true,
                        linkComponent: 'budgethead',
                        moduleName: 'BudgetHeads',
                        parent_id: 'parent_id',
                        parent_type: 'parent_type',
                    },
                    {
                        type: 'text',
                        name: 'sequence_no',
                        label: lang.LBL_SEQUENCE_NO,
                        required: true
                    },
                    {
                        type: 'text',
                        name: 'name',
                        label: lang.LBL_SUBHEAD_NAME,
                        required: true
                    },
                                       
                    {
                        type: 'selectbox',
                        name: 'status',
                        label: lang.LBL_STATUS,
                        required: false,
                        items: [
                            { value: 'Active' },
                            { value: 'Inactive' },
                        ],
                    },
                     {
                        type: 'text',
                        name: 'subhead_narration',
                        label: lang.LBL_SUBHEAD_NARRATION,
                        required: false
                    },
                    {
                    type:'checkbox',
                    name:'is_changeable',
                    label: lang.LBL_IS_CHANGEABLE,
                    value:'Yes',
                    required: false
                    },
                ],

                urls: 'api/modules/budgetsubheads',

                routePath: {
                    path: 'budgetsubheads',
                    detail: false
                }
            }
        },
        mounted() {
            this.childMethod()
        },
        methods: {
            childMethod() {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.routePath);
                }
            }
        },
    }
</script>